export default __webpack_public_path__ + "static/media/Ballroll_00183.0e568153.png";